import { useQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import {
  getCompany,
  getCompanyShippingAddresses,
  getDeliveryDays,
} from 'services/CompanyService';
import { AppMode } from 'store/Common/reducers/common';
import { ShippingType } from 'types/Order.types';

export const useGetCompanyShippingAddresses = (
  companyId: number,
  appMode: AppMode
) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANY_SHIPPING_ADDRESSES,
      companyId,
      appMode,
    ],
    queryFn: () => {
      return getCompanyShippingAddresses(companyId, appMode);
    },
  });

export const useGetDeliveryDays = (
  shippingType: ShippingType,
  shoppingCartId: string,
  enabled = true
) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_DELIVERY_DAYS, shippingType, shoppingCartId],
    queryFn: () => {
      return getDeliveryDays(shippingType, shoppingCartId);
    },
    enabled,
  });

// For default address
export const useGetCompanyForDefaultAddress = (companyId: number) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_COMPANY, companyId],
    queryFn: () => {
      return getCompany(companyId);
    },
  });
